import { api, handleResponse, handleError } from "./apiServices";
const baseURL = "/api/v1/venue/";
export const loginApi = data =>
  api()
    .post(`${baseURL}login`, data)
    .then(handleResponse)
    .catch(handleError);

export const logoutApi = token =>
  api(token)
    .get(`${baseURL}logout`)
    .then(handleResponse)
    .catch(handleError);

export const checkApi = (token, data) =>
  api(token, data)
    .post(`${baseURL}check`)
    .then(handleResponse)
    .catch(handleError);
